// This are to be used with other tags

const components = {
  submitBtn: '-submit-btn',
  saveBtn: '-save-btn',
  checkbox: '-check',
  textBox: '-text-box',
  signature: '-signature',
};

export default components;
